import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import {
  subCategories,
  childCategories,
  mainCategories,
  childSubCategories,
} from "../../actions/categories";
import { bulkProducts } from "../../actions/products";
import XLSX from "xlsx";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
const make_cols = (refstr) => {
  let o = [],
    C = XLSX.utils.decode_range(refstr).e.c + 1;
  for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i };
  return o;
};
class BulkProductsUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      handleDarkSideForce: "",
      subCategories: "",
      childCategories: "",
      mainCategories: "",
      buttonChange: "disabled",
      count: 0,
    };
  }
  async componentDidMount() {
    this.fileData();
  }
  fileData = async () => {
    const _res = await this.props.subCategories();
    const res = await this.props.childCategories();
    const __res = await this.props.mainCategories();
    const ___res = await this.props.childSubCategories();

    if (_res && res && __res && ___res) {
      this.setState({
        subCategories: _res.data,
        childCategories: res.data,
        mainCategories: __res.data,
        childSubCategories: ___res.data,
        buttonChange: "",
      });
    }
  };
  handleFile = (file) => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        header: 0,
        blankrows: true,
        defval: null,
        range: 0,
      });
      console.log(data);
      this.setState({
        buttonChange: "",
        data: data,
        cols: make_cols(ws["!ref"]),
      });
    };

    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };
  exportFile() {
    /* convert state to workbook */
    const ws = XLSX.utils.aoa_to_sheet(this.state.data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, "sheetjs.xlsx");
  }

  _submitHandler = async () => {
    // this.fileData();
    const {
      data,
      subCategories,
      childCategories,
      mainCategories,
      childSubCategories,
    } = this.state;

    var user = JSON.parse(localStorage.getItem("user"));
    let counter = 1;
    this.setState({ buttonChange: "disabled" });
    data.map(async (product_item, index1) => {
      counter++;
      setTimeout(() => {
        if (
          product_item.item_name &&
          product_item.item_name !== null &&
          product_item.item_name !== "Item Name" &&
          product_item.item_model !== "Model" &&
          product_item.product_id !== "general"
        ) {
          let subCheck = false;
          let formData = new FormData();
          if (product_item.sub_category_3 !== null) {
            childSubCategories.map((item, index) => {
              if (
                product_item.sub_category_3 !== null &&
                item.name.toLowerCase() ===
                  product_item.sub_category_3.toLowerCase()
              ) {
                subCheck = true;
                formData.append("category", item._id);
              }
            });
          }
          if (product_item.sub_category_2 !== null || subCheck === false) {
            subCategories.map((item, index) => {
              if (
                product_item.sub_category_2 !== null &&
                item.name.toLowerCase() ===
                  product_item.sub_category_2.toLowerCase()
              ) {
                subCheck = true;
                formData.append("category", item._id);
              }
            });
          }
          if (product_item.sub_category_1 !== null || subCheck === false) {
            childCategories.map((item, index) => {
              if (
                product_item.sub_category_1 !== null &&
                item.name.toLowerCase() ===
                  product_item.sub_category_1.toLowerCase()
              ) {
                subCheck = true;
                formData.append("category", item._id);
              }
            });
          }
          if (product_item.main_category !== null || subCheck === false) {
            mainCategories.map((item, index) => {
              if (
                product_item.main_category !== null &&
                item.name.toLowerCase() ===
                  product_item.main_category.toLowerCase()
              ) {
                subCheck = true;
                formData.append("category", item._id);
              }
            });
          }

          // if (subCheck === false && product_item.main_category !== null) {
          //   childCategories &&
          //     childCategories.map((item, index) => {
          //       if (
          //         product_item.main_category !== null &&
          //         item.name.toLowerCase() ===
          //           product_item.main_category.toLowerCase()
          //       ) {
          //         formData.append("category", item._id);
          //         // subCheck = true;
          //       }
          //     });
          // }
          // if (subCheck === false && product_item.main_category !== null) {
          //   subCategories.map((item, index) => {
          //     if (
          //       item.name.toLowerCase() ===
          //       product_item.main_category.toLowerCase()
          //     ) {
          //       formData.append("category", item._id);
          //     }
          //   });
          // }
          // if (subCheck === false && product_item.main_category !== null) {
          //   childSubCategories.map((item, index) => {
          //     if (
          //       item.name.toLowerCase() ===
          //       product_item.main_category.toLowerCase()
          //     ) {
          //       formData.append("category", item._id);
          //     }
          //   });
          // }
          // if (subCheck === false && product_item.sub_category_1 !== null) {
          //   subCategories.map((item, index) => {
          //     if (
          //       item.name.toLowerCase() ===
          //       product_item.sub_category_1.toLowerCase()
          //     ) {
          //       formData.append("category", item._id);
          //     }
          //   });
          // }

          if (product_item.item_status !== null) {
            formData.append(
              "status",
              product_item.item_status === "Enabled" ? true : false
            );
          }
          if (product_item.manufacturer !== null) {
            formData.append("manufecturer", product_item.manufacturer);
          }
          if (product_item.item_model !== null) {
            formData.append("modelNumber", product_item.item_model);
          }
          if (product_item.item_model !== null) {
            formData.append("model", product_item.item_model);
          }

          formData.append("sku", product_item.sku ? product_item.sku : "");
          formData.append("upc", product_item.upc ? product_item.upc : "");
          formData.append("title", product_item.item_name);
          formData.append("country", product_item.country);
          formData.append(
            "description",
            product_item.description !== null ? product_item.description : ""
          );

          if (
            product_item.bullet_feature_1 !== null &&
            product_item.bullet_feature_1 !== 0
          ) {
            formData.append("bullet", product_item.bullet_feature_1);
          }
          if (
            product_item.bullet_feature_2 !== null &&
            product_item.bullet_feature_2 !== 0
          ) {
            formData.append("bullet", product_item.bullet_feature_2);
          }
          if (
            product_item.bullet_feature_3 !== null &&
            product_item.bullet_feature_3 !== 0
          ) {
            formData.append("bullet", product_item.bullet_feature_3);
          }
          if (
            product_item.bullet_feature_4 !== null &&
            product_item.bullet_feature_4 !== 0
          ) {
            formData.append("bullet", product_item.bullet_feature_4);
          }
          if (
            product_item.bullet_feature_5 !== null &&
            product_item.bullet_feature_5 !== 0
          ) {
            formData.append("bullet", product_item.bullet_feature_5);
          }
          formData.append("price", product_item.map_price);
          formData.append("slug", product_item.item_name);
          formData.append(
            "minimumQuantity",
            product_item.minimum_order_quantity !== null
              ? product_item.minimum_order_quantity
              : 1
          );
          formData.append(
            "groupedItem",
            product_item.is_item_grouped === "Yes" ? true : false
          );
          formData.append(
            "parentModel",
            product_item.parent_model !== null ? product_item.parent_model : 0
          );

          // formData.append("manufecturer", user._id);
          if (product_item.main_image) {
            formData.append("images", product_item.main_image);
          }
          if (
            product_item.additional_image_1 !== null &&
            product_item.additional_image_1 !== 0
          ) {
            formData.append("images", product_item.additional_image_1);
          }
          if (
            product_item.additional_image_2 !== null &&
            product_item.additional_image_2 !== 0
          ) {
            formData.append("images", product_item.additional_image_2);
          }
          if (
            product_item.additional_image_3 !== null &&
            product_item.additional_image_3 !== 0
          ) {
            formData.append("images", product_item.additional_image_3);
          }
          if (
            product_item.additional_image_4 !== null &&
            product_item.additional_image_4 !== 0
          ) {
            formData.append("images", product_item.additional_image_4);
          }
          if (
            product_item.additional_image_5 !== null &&
            product_item.additional_image_5 !== 0
          ) {
            formData.append("images", product_item.additional_image_5);
          }
          if (
            product_item.additional_image_6 !== null &&
            product_item.additional_image_6 !== 0
          ) {
            formData.append("images", product_item.additional_image_6);
          }
          if (
            product_item.additional_image_7 !== null &&
            product_item.additional_image_7 !== 0
          ) {
            formData.append("images", product_item.additional_image_7);
          }
          if (
            product_item.additional_image_8 !== null &&
            product_item.additional_image_8 !== 0
          ) {
            formData.append("images", product_item.additional_image_8);
          }
          if (
            product_item.additional_image_9 !== null &&
            product_item.additional_image_9 !== 0
          ) {
            formData.append("images", product_item.additional_image_9);
          }
          if (
            product_item.additional_image_10 !== null &&
            product_item.additional_image_10 !== 0
          ) {
            formData.append("images", product_item.additional_image_10);
          }
          if (
            product_item.additional_image_11 !== null &&
            product_item.additional_image_11 !== 0
          ) {
            formData.append("images", product_item.additional_image_11);
          }
          if (
            product_item.item_video !== null &&
            product_item.item_video !== 0
          ) {
            formData.append("images", product_item.item_video);
          }

          if (
            product_item.item_style_1 !== null &&
            product_item.item_style_1 !== 0
          ) {
            formData.append("style", product_item.item_style_1);
          }
          if (
            product_item.item_style_2 !== null &&
            product_item.item_style_2 !== 0
          ) {
            formData.append("style", product_item.item_style_2);
          }
          if (
            product_item.item_style_3 !== null &&
            product_item.item_style_3 !== 0
          ) {
            formData.append("style", product_item.item_style_3);
          }
          if (
            product_item.item_style_4 !== null &&
            product_item.item_style_4 !== 0
          ) {
            formData.append("style", product_item.item_style_4);
          }
          if (
            product_item.item_style_5 !== null &&
            product_item.item_style_5 !== 0
          ) {
            formData.append("style", product_item.item_style_5);
          }

          formData.append("brand", user._id);

          if (
            product_item.item_material_1 !== null &&
            product_item.item_material_1 !== 0
          ) {
            formData.append("material", product_item.item_material_1);
          }
          if (
            product_item.item_material_2 !== null &&
            product_item.item_material_2 !== 0
          ) {
            formData.append("material", product_item.item_material_2);
          }
          if (
            product_item.item_material_3 !== null &&
            product_item.item_material_3 !== 0
          ) {
            formData.append("material", product_item.item_material_3);
          }
          if (
            product_item.item_material_4 !== null &&
            product_item.item_material_4 !== 0
          ) {
            formData.append("material", product_item.item_material_4);
          }
          if (
            product_item.item_material_5 !== null &&
            product_item.item_material_5 !== 0
          ) {
            formData.append("material", product_item.material_type_5);
          }

          if (product_item.package_height_1 !== null) {
            formData.append(
              "weightAndDimension",
              JSON.stringify({
                name: "Item Height - In",
                value: `${product_item.package_height_1}`,
              })
            );
          }

          if (product_item.package_weight_1 !== null) {
            formData.append(
              "weightAndDimension",
              JSON.stringify({
                name: "Item Weight - Lbs",
                value: `${product_item.package_weight_1}`,
              })
            );
          }

          if (product_item.package_width_1 !== null) {
            formData.append(
              "weightAndDimension",
              JSON.stringify({
                name: "Item Width - in",
                value: `${product_item.package_width_1}`,
              })
            );
          }

          if (product_item.package_length_1 !== null) {
            formData.append(
              "weightAndDimension",
              JSON.stringify({
                name: "Item Length - in",
                value: `${product_item.package_length_1}`,
              })
            );
          }
          if (
            product_item.item_depth__in_ &&
            product_item.item_depth__in_ !== null
          ) {
            formData.append(
              "weightAndDimension",
              JSON.stringify({
                name: "Item Depth - In",
                value: `${product_item.item_depth__in_}`,
              })
            );
          }

          if (
            product_item.item_diameter__in_ &&
            product_item.item_diameter__in_ !== null
          ) {
            formData.append(
              "weightAndDimension",
              JSON.stringify({
                name: "Item Diameter - In ",
                value: `${product_item.item_diameter__in_}`,
              })
            );
          }

          formData.append(
            "indoor",
            product_item.indoor_use === "yes" ? true : false
          );
          formData.append(
            "ourdoor",
            product_item.outdoor_use === "yes" ? true : false
          );
          formData.append("tag", product_item.item_name);

          formData.append("sortOrder", 1);
          formData.append("quantity", 50);

          formData.append("outOfStock", false);
          formData.append(
            "requireShipping",
            product_item.use_shipping === "Yes" ? true : false
          );

          // formData.append("category", product_item);
          formData.append("vendor", user._id);
          formData.append("metaTagTitle", product_item.item_name);
          formData.append("metaTagDescription", product_item.item_name);
          formData.append("metaTagKeyword", product_item.item_name);
          formData.append("seoKeyword", product_item.item_name);
          formData.append("lengthClass", product_item.package_length_1);
          // formData.append("weight", product_item.package_weight_lbs___1);
          formData.append("weigthClass", product_item.package_weight_1);
          formData.append("weight", Number(product_item.package_weight_1));
          formData.append("length", Number(product_item.package_length_1));
          formData.append("width", Number(product_item.package_width_1));
          formData.append("height", Number(product_item.package_height_1));
          if (product_item.sales_uom !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Sales UOM",
                value: product_item.sales_uom,
              })
            );
          }
          if (product_item.top_seller !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Top Seller (Yes/No)",
                value: product_item.top_seller,
              })
            );
          }
          if (product_item.ada_compliant !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "ADA Compliant (Yes/No)",
                value: product_item.ada_compliant,
              })
            );
          }
          if (product_item.proposition_65_compliance !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Proposition 65 Compliance (Yes/No)",
                value: product_item.proposition_65_compliance,
              })
            );
          }
          if (product_item.eco_friendly !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Eco Friendly (Yes/No)",
                value: product_item.eco_friendly,
              })
            );
          }
          if (product_item.composite_wood_products !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Composite Wood Product (Yes/No)",
                value: product_item.composite_wood_products,
              })
            );
          }
          if (product_item.reclaimed_wood !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Reclaimed Wood (Yes/No)",
                value: product_item.reclaimed_wood,
              })
            );
          }
          if (product_item.water_resistant !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Water Resistant (Yes/No)",
                value: product_item.water_resistant,
              })
            );
          }
          if (product_item.water_absorption !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Water Absorption",
                value: product_item.water_absorption,
              })
            );
          }
          if (product_item.stain_resistant !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Stain Resistant (Yes/No)",
                value: product_item.stain_resistant,
              })
            );
          }
          if (product_item.abrasion_resistance !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Abrasion Resistance (Yes/No)",
                value: product_item.abrasion_resistance,
              })
            );
          }
          if (product_item.freeze_resistance !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Freeze Resistance (Yes/No)",
                value: product_item.freeze_resistance,
              })
            );
          }
          if (product_item.weather_resistant !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Weather Resistant (Yes/No)",
                value: product_item.weather_resistant,
              })
            );
          }
          if (product_item.mildew_resistant !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Mildew Resistant (Yes/No)",
                value: product_item.mildew_resistant,
              })
            );
          }
          if (product_item.hypoallergenic !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Hypoallergenic (Yes/No)",
                value: product_item.hypoallergenic,
              })
            );
          }
          if (product_item.recycled_content !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Recycled Content (Yes/No)",
                value: product_item.recycled_content,
              })
            );
          }
          if (product_item.moisture_wicking !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Moisture Wicking (Yes/No)",
                value: product_item.moisture_wicking,
              })
            );
          }
          if (product_item.certified_wet_damp !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Certified Wet or Damp",
                value: product_item.certified_wet_damp,
              })
            );
          }
          if (product_item.item_reversible !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Reversible (Yes/No)",
                value: product_item.item_reversible,
              })
            );
          }
          if (product_item.item_cover !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Product Cover",
                value: product_item.item_cover,
              })
            );
          }
          if (product_item.removable_cover !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Removable Cover (Yes/No)",
                value: product_item.removable_cover,
              })
            );
          }
          if (product_item.item_embroidered !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Embroidered (Yes/No)",
                value: product_item.item_embroidered,
              })
            );
          }
          if (product_item.item_applique !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Applique (Yes/No)",
                value: product_item.item_applique,
              })
            );
          }
          if (product_item.item_buttons !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Buttons (Yes/No)",
                value: product_item.item_buttons,
              })
            );
          }
          if (product_item.item_sequined !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Sequined (Yes/No)",
                value: product_item.item_sequined,
              })
            );
          }
          if (product_item.item_tassels_included !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Tassels Included (Yes/No)",
                value: product_item.item_tassels_included,
              })
            );
          }
          if (product_item.item_backing_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Backing Material",
                value: product_item.item_backing_material,
              })
            );
          }
          if (product_item.item_collection !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Collection Name",
                value: product_item.item_collection,
              })
            );
          }
          if (product_item.collection_description !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Collection Description",
                value: product_item.collection_description,
              })
            );
          }
          if (product_item.item_style_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Style 1",
                value: product_item.item_style_1,
              })
            );
          }
          if (product_item.item_style_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Style 2",
                value: product_item.item_style_2,
              })
            );
          }
          if (product_item.item_style_3 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Style 3",
                value: product_item.item_style_3,
              })
            );
          }
          if (product_item.item_style_4 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Style 4",
                value: product_item.item_style_4,
              })
            );
          }
          if (product_item.item_style_5 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Style 5",
                value: product_item.item_style_5,
              })
            );
          }
          if (product_item.item_style_6 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Style 6",
                value: product_item.item_style_6,
              })
            );
          }
          if (product_item.reverse_side_style !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Revers Side Style",
                value: product_item.reverse_side_style,
              })
            );
          }
          if (product_item.item_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Color",
                value: product_item.item_color,
              })
            );
          }
          if (product_item.color_family !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Color Family",
                value: product_item.color_family,
              })
            );
          }
          if (product_item.item_pattern_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Pattern 1",
                value: product_item.item_pattern_1,
              })
            );
          }
          if (product_item.item_pattern_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Pattern 2",
                value: product_item.item_pattern_2,
              })
            );
          }
          if (product_item.reverse_side_pattern !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Reverse Side Pattern",
                value: product_item.reverse_side_pattern,
              })
            );
          }
          if (product_item.item_flange !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Flange Color",
                value: product_item.item_flange,
              })
            );
          }
          if (product_item.item_tassel_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Tassel Color",
                value: product_item.item_tassel_color,
              })
            );
          }
          if (product_item.tassel_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Tassel Type",
                value: product_item.tassel_type,
              })
            );
          }
          if (product_item.item_piping_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Piping Color",
                value: product_item.item_piping_color,
              })
            );
          }
          if (product_item.reverse_side_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Reverse Side Color",
                value: product_item.reverse_side_color,
              })
            );
          }
          if (product_item.item_construction !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Construction",
                value: product_item.item_construction,
              })
            );
          }
          if (product_item.item_technique !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Technique",
                value: product_item.item_technique,
              })
            );
          }
          if (product_item.distressed_finish !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Distressed Finish (Yes/No)",
                value: product_item.distressed_finish,
              })
            );
          }
          if (product_item.item_finish_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Finish 1",
                value: product_item.item_finish_1.toString(),
              })
            );
          }
          if (product_item.item_finish_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Finish 2",
                value: product_item.item_finish_2,
              })
            );
          }
          if (product_item.item_finish_3 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Finish 3",
                value: product_item.item_finish_3,
              })
            );
          }
          if (product_item.item_finish_group !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Finish Group",
                value: product_item.item_finish_group,
              })
            );
          }
          if (product_item.item_material_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Material Type 1",
                value: product_item.item_material_1,
              })
            );
          }
          if (product_item.item_material_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Material Type 2",
                value: product_item.item_material_2,
              })
            );
          }
          if (product_item.item_material_3 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Material Type 3",
                value: product_item.item_material_3,
              })
            );
          }
          if (product_item.item_material_4 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Material Type 4",
                value: product_item.item_material_4,
              })
            );
          }
          if (product_item.item_material_5 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Material Type 5",
                value: product_item.item_material_5,
              })
            );
          }
          if (product_item.item_material_front !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Material Type Front",
                value: product_item.item_material_front,
              })
            );
          }
          if (product_item.item_material_back !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Material Type Back",
                value: product_item.item_material_back,
              })
            );
          }
          if (product_item.fill_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Fill Material",
                value: product_item.fill_material,
              })
            );
          }
          if (product_item.item_border !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Border",
                value: product_item.item_border,
              })
            );
          }
          if (product_item.assembly_required !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Assembly Required (Yes/No)",
                value: product_item.assembly_required,
              })
            );
          }
          if (product_item.item_adjustable !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Adjustable (Yes/No)",
                value: product_item.item_adjustable,
              })
            );
          }
          if (product_item.set_number !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Set of",
                value: product_item.set_number,
              })
            );
          }
          if (product_item.item_shape !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shape",
                value: product_item.item_shape,
              })
            );
          }
          if (product_item.item_size !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Size",
                value: product_item.item_size,
              })
            );
          }
          if (product_item.item_size_group !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Size Group",
                value: product_item.item_size_group,
              })
            );
          }
          if (product_item.item_dimensions !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Dimensions (L x W x H)",
                value: product_item.item_dimensions,
              })
            );
          }
          if (product_item.item_length !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Length (in)",
                value: product_item.item_length,
              })
            );
          }
          if (product_item.item_overall_length_range !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Overall Length Range (in)",
                value: product_item.item_overall_length_range,
              })
            );
          }
          if (product_item.item_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Height (in)",
                value: product_item.item_height,
              })
            );
          }
          if (product_item.item_overall_height_range !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Overall Height Range (in)",
                value: product_item.item_overall_height_range,
              })
            );
          }
          if (product_item.item_adjustable_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Adjustable Height (in)",
                value: product_item.item_adjustable_height,
              })
            );
          }
          if (product_item.item_pile_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Pile Type",
                value: product_item.item_pile_type,
              })
            );
          }
          if (product_item.item_pile_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Pile Height (in)",
                value: product_item.item_pile_height,
              })
            );
          }
          if (product_item.item_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Width (in)",
                value: product_item.item_width,
              })
            );
          }
          if (product_item.item_overall_width_range !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Overall Width Range (in)",
                value: product_item.item_overall_width_range,
              })
            );
          }
          if (product_item.item_diameter !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Diameter (in)",
                value: product_item.item_diameter,
              })
            );
          }
          if (product_item.item_overall_diameter_range !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Overall Diameter Range (in)",
                value: product_item.item_overall_diameter_range,
              })
            );
          }
          if (product_item.item_weight !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Weight (lbs)",
                value: product_item.item_weight,
              })
            );
          }
          if (product_item.weight_capacity !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Weight Capacity (lbs)",
                value: product_item.weight_capacity,
              })
            );
          }
          if (product_item.item_depth !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Depth (in)",
                value: product_item.item_depth,
              })
            );
          }

          if (product_item.item_overall_depth_range !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Overall Depth Range (in)",
                value: product_item.item_overall_depth_range,
              })
            );
          }
          if (product_item.item_thickness !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Thickness (in)",
                value: product_item.item_thickness,
              })
            );
          }
          if (product_item.item_center_to_center !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Center to center (in)",
                value: product_item.item_center_to_center,
              })
            );
          }
          if (product_item.item_center_to_center_range !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Center to Center Range (in)",
                value: product_item.item_center_to_center_range,
              })
            );
          }
          if (product_item.item_clearance !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Clearance (in)",
                value: product_item.item_clearance,
              })
            );
          }
          if (product_item.item_fringe !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Fringe (Yes/No)",
                value: product_item.item_fringe,
              })
            );
          }
          if (product_item.item_fringe_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Fringe Type",
                value: product_item.item_fringe_type,
              })
            );
          }
          if (product_item.item_flange !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Flange (Yes/No)",
                value: product_item.item_flange,
              })
            );
          }
          if (product_item.item_closure_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Closure Type",
                value: product_item.item_closure_type,
              })
            );
          }
          if (product_item.item_foot_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Foot Width (in)",
                value: product_item.item_foot_width,
              })
            );
          }
          if (product_item.item_projection !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Item Projection (in)",
                value: product_item.item_projection,
              })
            );
          }
          if (product_item.with_without_screws !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "With or Without Screws",
                value: product_item.with_without_screws,
              })
            );
          }
          if (product_item.recommended_screws !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Recommended Screws",
                value: product_item.recommended_screws,
              })
            );
          }
          if (product_item.helpful_tips !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Product Helpful Tips",
                value: product_item.helpful_tips,
              })
            );
          }
          if (product_item.indoor_use !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Indoor Use (Yes/No)",
                value: product_item.indoor_use,
              })
            );
          }
          if (product_item.outdoor_use !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Outdoor Use (Yes/No)",
                value: product_item.outdoor_use,
              })
            );
          }
          if (product_item.installation_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Installation Type",
                value: product_item.installation_type,
              })
            );
          }
          if (product_item.sink_back_front !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Sink Back to Front Dimension",
                value: product_item.sink_back_front,
              })
            );
          }
          if (product_item.sink_bowl_depth !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Sink Bowl Depth",
                value: product_item.sink_bowl_depth,
              })
            );
          }
          if (product_item.sink_gauge !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Gauge",
                value: product_item.sink_gauge,
              })
            );
          }
          if (product_item.overflow_drain !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Overflow Drain (Yes/No)",
                value: product_item.overflow_drain,
              })
            );
          }
          if (product_item.sink_shape !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Sink Shape",
                value: product_item.sink_shape,
              })
            );
          }
          if (product_item.drain_placement !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Drain Placement",
                value: product_item.drain_placement,
              })
            );
          }
          if (product_item.spout_reach_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Spout Reach Width (in)",
                value: product_item.spout_reach_width,
              })
            );
          }
          if (product_item.size_class !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Size Class",
                value: product_item.size_class,
              })
            );
          }
          if (product_item.top_and_bowl_preinstalled !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Top and Bowl Pre-Installed? (Yes/No)",
                value: product_item.top_and_bowl_preinstalled,
              })
            );
          }
          if (product_item.coordinating_mirrors_for_vanity !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Coordinating Mirrors for Vanity",
                value: product_item.coordinating_mirrors_for_vanity,
              })
            );
          }
          if (product_item.spout_reach_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Spout Reach Height (in)",
                value: product_item.spout_reach_height,
              })
            );
          }
          if (product_item.water_flow_rate !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Water Flow Rate (GPM)",
                value: product_item.water_flow_rate,
              })
            );
          }
          if (product_item.pullout_sprayer !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Pullout Sprayer (Yes/No)",
                value: product_item.pullout_sprayer,
              })
            );
          }
          if (product_item.sensor_activated !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Sensor Activated (Yes/No)",
                value: product_item.sensor_activated,
              })
            );
          }
          if (product_item.number_handles !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Number of Handles",
                value: product_item.number_handles,
              })
            );
          }
          if (product_item.handle_style !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Handle Style",
                value: product_item.handle_style,
              })
            );
          }
          if (product_item.number_faucet_holes_required !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Number of Faucet Holes Required",
                value: product_item.number_faucet_holes_required,
              })
            );
          }
          if (product_item.water_flow_controls !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Water Flow Controls",
                value: product_item.water_flow_controls,
              })
            );
          }
          if (product_item.valve_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Valve Type",
                value: product_item.valve_type,
              })
            );
          }
          if (product_item.bulb_count_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Count 1",
                value: product_item.bulb_count_1,
              })
            );
          }
          if (product_item.bulb_wattage_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Wattage 1",
                value: product_item.bulb_wattage_1,
              })
            );
          }
          if (product_item.bulb_type_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Type 1",
                value: product_item.bulb_type_1,
              })
            );
          }
          if (product_item.bulb_base_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Base 1",
                value: product_item.bulb_base_1,
              })
            );
          }
          if (product_item.bulb_included_1 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Included 1 (Yes/No)",
                value: product_item.bulb_included_1,
              })
            );
          }
          if (product_item.bulb_count_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Count 2",
                value: product_item.bulb_count_2,
              })
            );
          }
          if (product_item.bulb_wattage_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Wattage 2",
                value: product_item.bulb_wattage_2,
              })
            );
          }
          if (product_item.bulb_type_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Type 2",
                value: product_item.bulb_type_2,
              })
            );
          }
          if (product_item.bulb_base_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Base 2",
                value: product_item.bulb_base_2,
              })
            );
          }
          if (product_item.bulb_included_2 !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Bulb Included 2 (Yes/No)",
                value: product_item.bulb_included_2,
              })
            );
          }
          if (product_item.led !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "LED (Yes/No)",
                value: product_item.led,
              })
            );
          }
          if (product_item.total_lumens !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Total Lumens",
                value: product_item.total_lumens,
              })
            );
          }
          if (product_item.color_temperature !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Color Temperature",
                value: product_item.color_temperature,
              })
            );
          }
          if (product_item.cri !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Color Rendering Index",
                value: product_item.cri,
              })
            );
          }
          if (product_item.voltage !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Voltage",
                value: product_item.voltage,
              })
            );
          }
          if (product_item.switch_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Switch Type",
                value: product_item.switch_type,
              })
            );
          }
          if (product_item.dimmable !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Dimmable (Yes/No)",
                value: product_item.dimmable,
              })
            );
          }
          if (product_item.lamp_base_dimensions !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Lamp Base Dimensions (in)",
                value: product_item.lamp_base_dimensions,
              })
            );
          }
          if (product_item.backplate_canopy_dimensions !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Backplate/Canopy Dimensions (in)",
                value: product_item.backplate_canopy_dimensions,
              })
            );
          }
          if (product_item.extension_rods !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Extension Rods (in)",
                value: product_item.extension_rods,
              })
            );
          }
          if (product_item.shade_glass_description !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shade/Glass Description",
                value: product_item.shade_glass_description,
              })
            );
          }
          if (product_item.shade_glass_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shade/Glass Materials",
                value: product_item.shade_glass_material,
              })
            );
          }
          if (product_item.shade_glass_finish !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shade/Glass Finish",
                value: product_item.shade_glass_finish,
              })
            );
          }
          if (product_item.shade_glass_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shade/Glass Width (in)",
                value: product_item.shade_glass_width,
              })
            );
          }
          if (product_item.shade_glass_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shade/Glass Height (in)",
                value: product_item.shade_glass_height,
              })
            );
          }
          if (product_item.shade_shape !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shade Shape",
                value: product_item.shade_shape,
              })
            );
          }
          if (product_item.harp_spider !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Harp/Spider",
                value: product_item.harp_spider,
              })
            );
          }
          if (product_item.code_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Cord Color",
                value: product_item.code_color,
              })
            );
          }
          if (product_item.cord_length !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Cord Length (in)",
                value: product_item.cord_length,
              })
            );
          }
          if (product_item.build_in_outlet !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Build-in Outlet (Yes/No)",
                value: product_item.build_in_outlet,
              })
            );
          }
          if (product_item.chain_length !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Chain Length (in)",
                value: product_item.chain_length,
              })
            );
          }
          if (product_item.mirror_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Mirror Width (in)",
                value: product_item.mirror_width,
              })
            );
          }
          if (product_item.mirror_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Mirror Height (in)",
                value: product_item.mirror_height,
              })
            );
          }
          if (product_item.mirror_shape !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Mirror Shape",
                value: product_item.mirror_shape,
              })
            );
          }
          if (product_item.print_process !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Print Process",
                value: product_item.print_process,
              })
            );
          }
          if (product_item.printed_on !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Printed On",
                value: product_item.printed_on,
              })
            );
          }
          if (product_item.hang_orientation !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Hang Orientation",
                value: product_item.hang_orientation,
              })
            );
          }
          if (product_item.hang_hardware !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Hang Hardware",
                value: product_item.hang_hardware,
              })
            );
          }
          if (product_item.tabletop_thickness !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Tabletop Thickness (in)",
                value: product_item.tabletop_thickness,
              })
            );
          }
          if (product_item.furniture_stackable !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Furniture Stackable (Yes/No)",
                value: product_item.furniture_stackable,
              })
            );
          }
          if (product_item.furniture_legs !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Furniture Legs (Yes/No)",
                value: product_item.furniture_legs,
              })
            );
          }
          if (product_item.beveled_glass !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Beveled Glass (Yes/No)",
                value: product_item.beveled_glass,
              })
            );
          }
          if (product_item.gloss_level !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Gloss Level",
                value: product_item.gloss_level,
              })
            );
          }
          if (product_item.tempered_glass !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Tempered Glass",
                value: product_item.tempered_glass,
              })
            );
          }
          if (product_item.wood_finish !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Wood Finish",
                value: product_item.wood_finish,
              })
            );
          }
          if (product_item.furniture_headboard !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Furniture Headboard (Yes/No)",
                value: product_item.furniture_headboard,
              })
            );
          }
          if (product_item.furniture_headboard_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Headboard Height (in)",
                value: product_item.furniture_headboard_height,
              })
            );
          }
          if (product_item.furniture_headboard_length !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Headboard Length (in)",
                value: product_item.furniture_headboard_length,
              })
            );
          }
          if (product_item.furniture_headboard_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Headboard Width (in)",
                value: product_item.furniture_headboard_width,
              })
            );
          }
          if (product_item.drawer_count !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Drawer Count",
                value: product_item.drawer_count,
              })
            );
          }
          if (product_item.furniture_arm_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Arm Color",
                value: product_item.furniture_arm_color,
              })
            );
          }
          if (product_item.furniture_lumbar_support !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Lumbar Support (Yes/No)",
                value: product_item.furniture_lumbar_support,
              })
            );
          }
          if (product_item.furniture_headrest_included !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Headrest Included (Yes/No)",
                value: product_item.furniture_headrest_included,
              })
            );
          }
          if (product_item.furniture_frame_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Frame Color",
                value: product_item.furniture_frame_color,
              })
            );
          }
          if (product_item.furniture_paint_type !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Paint Type",
                value: product_item.furniture_paint_type,
              })
            );
          }
          if (product_item.frame_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Frame Material",
                value: product_item.frame_material,
              })
            );
          }
          if (product_item.item_upholstered !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Upholstered (Yes/No)",
                value: product_item.item_upholstered,
              })
            );
          }
          if (product_item.furniture_footrest !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Footrest (Yes/No)",
                value: product_item.furniture_footrest,
              })
            );
          }
          if (product_item.footrest_distance_to_floor !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Footrest Distance to Seat (in)",
                value: product_item.footrest_distance_to_floor,
              })
            );
          }
          if (product_item.upholstery_fill_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Upholstery Fill Material",
                value: product_item.upholstery_fill_material,
              })
            );
          }
          if (product_item.upholstery_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Upholstery Material",
                value: product_item.upholstery_material,
              })
            );
          }
          if (product_item.upholstery_color !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Upholstery Color",
                value: product_item.upholstery_color,
              })
            );
          }
          if (product_item.tufted_upholstery !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Tufted Upholstery",
                value: product_item.tufted_upholstery,
              })
            );
          }
          if (product_item.seat_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Seat Material",
                value: product_item.seat_material,
              })
            );
          }
          if (product_item.seat_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Seat Width (in)",
                value: product_item.seat_width,
              })
            );
          }
          if (product_item.seat_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Seat Height (in)",
                value: product_item.seat_height,
              })
            );
          }
          if (product_item.seat_depth !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Seat Depth (in)",
                value: product_item.seat_depth,
              })
            );
          }
          if (product_item.item_swivel !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Swivel (Yes/No)",
                value: product_item.item_swivel,
              })
            );
          }
          if (product_item.item_arms !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Arms (Yes/No)",
                value: product_item.item_arms,
              })
            );
          }
          if (product_item.seating_capacity !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Seating Capacity",
                value: product_item.seating_capacity,
              })
            );
          }
          if (product_item.furniture_arm_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Arm Material",
                value: product_item.furniture_arm_material,
              })
            );
          }
          if (product_item.product_has_a_back !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Product has a back (Yes/No)",
                value: product_item.product_has_a_back,
              })
            );
          }
          if (product_item.furniture_back_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Back Height (in)",
                value: product_item.furniture_back_height,
              })
            );
          }
          if (product_item.removable_cushions !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Removable Cushions (Yes/No)",
                value: product_item.removable_cushions,
              })
            );
          }
          if (product_item.reversible_cushions !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Reversible Cushions (Yes/No)",
                value: product_item.reversible_cushions,
              })
            );
          }
          if (product_item.seat_material_variety !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Seat Material Variety",
                value: product_item.seat_material_variety,
              })
            );
          }
          if (product_item.seat_cushion_fill_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Seat Cushion Fill Material",
                value: product_item.seat_cushion_fill_material,
              })
            );
          }
          if (product_item.back_cushion_fill_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Back Cushion Fill Material",
                value: product_item.back_cushion_fill_material,
              })
            );
          }
          if (product_item.cleaning_code !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Cleaning Code",
                value: product_item.cleaning_code,
              })
            );
          }
          if (product_item.rub_count !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Rub Count",
                value: product_item.rub_count,
              })
            );
          }
          if (product_item.frame_material_variety !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Frame Material Variety",
                value: product_item.frame_material_variety,
              })
            );
          }
          if (product_item.recommended_cabinet_size !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Recommended Cabinet Size",
                value: product_item.recommended_cabinet_size,
              })
            );
          }
          if (product_item.minimum_cabinet_opening !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Minimum Cabinet Opening (in)",
                value: product_item.minimum_cabinet_opening,
              })
            );
          }
          if (product_item.hinge_overlay !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Hinge Overlay",
                value: product_item.hinge_overlay,
              })
            );
          }
          if (product_item.hinge_degree_of_opening !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Hinge Degree of Opening",
                value: product_item.hinge_degree_of_opening,
              })
            );
          }
          if (product_item.hinge_crank_amount !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Hinge Crank Amount",
                value: product_item.hinge_crank_amount,
              })
            );
          }
          if (product_item.soft_closing !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Soft Closing (Yes/No)",
                value: product_item.soft_closing,
              })
            );
          }
          if (product_item.self_closing !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Self Closing (Yes/No)",
                value: product_item.self_closing,
              })
            );
          }
          if (product_item.furniture_arm_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Furniture Arm Height (in)",
                value: product_item.furniture_arm_height,
              })
            );
          }
          if (product_item.furniture_arm_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Furniture Arm Width (in)",
                value: product_item.furniture_arm_width,
              })
            );
          }
          if (product_item.furniture_arm_depth !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Furniture Arm Depth (in)",
                value: product_item.furniture_arm_depth,
              })
            );
          }
          if (product_item.furniture_leg_glides !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Leg Glides (Yes/No)",
                value: product_item.furniture_leg_glides,
              })
            );
          }
          if (product_item.feet_material !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Feet Material",
                value: product_item.feet_material,
              })
            );
          }
          if (product_item.edge_treatment !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Edge Treatment",
                value: product_item.edge_treatment,
              })
            );
          }
          if (product_item.shade_variation !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Shade Variation",
                value: product_item.shade_variation,
              })
            );
          }
          if (product_item.nominal_size !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Nominal Size",
                value: product_item.nominal_size,
              })
            );
          }
          if (product_item.grout_joint !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Grout Joint Recommendation (in)",
                value: product_item.grout_joint,
              })
            );
          }
          if (product_item.tile_thickness !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Tile Thickness (in)",
                value: product_item.tile_thickness,
              })
            );
          }
          if (product_item.case_length !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Case Length (in)",
                value: product_item.case_length,
              })
            );
          }
          if (product_item.case_width !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Case Width (in)",
                value: product_item.case_width,
              })
            );
          }
          if (product_item.case_height !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Case Height (in)",
                value: product_item.case_height,
              })
            );
          }
          if (product_item.case_upc !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Case UPC",
                value: product_item.case_upc,
              })
            );
          }
          if (product_item.sf_pc !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "Square Ft. per Piece",
                value: product_item.sf_pc,
              })
            );
          }
          if (product_item.lb_pc !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "LB/PC",
                value: product_item.lb_pc,
              })
            );
          }
          if (product_item.pc_ct !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "PC/CT",
                value: product_item.pc_ct,
              })
            );
          }
          if (product_item.sf_ct !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "SF/CT",
                value: product_item.sf_ct,
              })
            );
          }
          if (product_item.lb_ct !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "LB/CT",
                value: product_item.lb_ct,
              })
            );
          }
          if (product_item.lf_ct !== null) {
            formData.append(
              "specification",
              JSON.stringify({
                name: "LF/CT",
                value: product_item.lf_ct,
              })
            );
          }

          this.setState({ loading: true });
          // if (this.state.count < 25) {
          this.props.bulkProducts(formData);
          // } else {
          //   this.setState({ data: "" });
          // }
        }
        this.setState({ count: index1 });
      }, counter * 500);
    });
    this.setState({ loading: false, buttonChange: "", count: "All" });
  };
  render() {
    return (
      <Fragment>
        <div className="bulproduct-container wrapper-90 max-1600">
          <BreadCrumb title={`My Account`} />
          <div className="container-fluid px-0">
            <div className="row">
              <AccountLeftSidebar />
              <div className="col-md-9">
                <div className="bulk-prod-content">
                  <header className="bul-p-header">
                    <h3 className="bulk-p-title">Bulk Product Upload</h3>
                  </header>
                  <div className="bulk-first-h">
                    <span>
                      <i className="fa fa-bars" />
                    </span>
                    <span> Bulk Product Upload</span>
                  </div>
                  <div className="bulk-prod-body">
                    <section className="bulk-section">
                      <div className="bulk-section-content">
                        <p className="bulk-time">
                          {this.state.loading && this.state.loading === true ? (
                            <div className="text-center">
                              <h5>
                                you have added {`${this.state.count}`} products
                              </h5>
                            </div>
                          ) : (
                            ""
                          )}
                        </p>
                      </div>
                    </section>{" "}
                    <hr />
                    <section className="bulk-import-section">
                      <div className="bulk-section-content">
                        <h5 className="imort-bulk-title">
                          BULK PRODUCT IMPORT
                        </h5>
                        <div className="bulk-import-options">
                          <div className="checkout-inps bulk-option">
                            <span className="selectcountry-hint">
                              Select Language
                            </span>
                            <select className="countrySelect">
                              <option value="select country" disabled>
                                Select Language
                              </option>
                              <option value="United States">English</option>
                              <option value="french">French</option>
                            </select>
                          </div>
                          <div className="chose-file-bulk bulk-option">
                            <label
                              htmlFor="upload-bulk"
                              className="upload-bulk-file"
                            >
                              Select CSV of products
                              <DragDropFile handleFile={this.handleFile}>
                                <div className="row">
                                  <div className="col-xs-12">
                                    <DataInput handleFile={this.handleFile} />
                                  </div>
                                </div>
                              </DragDropFile>
                            </label>
                          </div>
                          <div className="import-bulk bulk-option">
                            <button
                              className={`bulk-import-btn ${this.state.buttonChange}`}
                              onClick={this._submitHandler}
                            >
                              <span>Import</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

/* -------------------------------------------------------------------------- */

/*
  Simple HTML5 file drag-and-drop wrapper
  usage: <DragDropFile handleFile={handleFile}>...</DragDropFile>
    handleFile(file:File):void;
*/
class DragDropFile extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
  }
  suppress(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  }
  onDrop(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    const files = evt.dataTransfer.files;
    if (files && files[0]) this.props.handleFile(files[0]);
  }
  render() {
    return (
      <div
        onDrop={this.onDrop}
        onDragEnter={this.suppress}
        onDragOver={this.suppress}
      >
        {this.props.children}
      </div>
    );
  }
}

/*
  Simple HTML5 file input wrapper
  usage: <DataInput handleFile={callback} />
    handleFile(file:File):void;
*/
class DataInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) this.props.handleFile(files[0]);
  }
  render() {
    return (
      <form className="form-inline">
        <div className="form-group" style={{ marginLeft: "12px" }}>
          <label htmlFor="file"> </label>
          <input
            type="file"
            id="file"
            accept={SheetJSFT}
            onChange={this.handleChange}
          />
        </div>
      </form>
    );
  }
}

/* list of supported file types */
const SheetJSFT = [
  "xlsx",
  "xlsb",
  "xlsm",
  "xls",
  "xml",
  "csv",
  "txt",
  "ods",
  "fods",
  "uos",
  "sylk",
  "dif",
  "dbf",
  "prn",
  "qpw",
  "123",
  "wb*",
  "wq*",
  "html",
  "htm",
]
  .map(function (x) {
    return "." + x;
  })
  .join(",");
subCategories.prototype = {
  subCategories: PropTypes.func.isRequired,
};
bulkProducts.prototype = {
  bulkProducts: PropTypes.func.isRequired,
};
childCategories.prototype = {
  childCategories: PropTypes.func.isRequired,
};
mainCategories.prototype = {
  mainCategories: PropTypes.func.isRequired,
};
childSubCategories.prototype = {
  childSubCategories: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default withRouter(
  connect(mapStateToProps, {
    subCategories,
    bulkProducts,
    childCategories,
    mainCategories,
    childSubCategories,
  })(BulkProductsUpload)
);
